import React from 'react';
import ATabs from 'antd-mobile/lib/tabs';



export default class Tabs extends ATabs {}